import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import OpenNetworkLogComponent from '../components/open-network-log.component';
import { selectListItems } from '../../../../../../redux/library/selector';
import { opennetworkDomains } from '../../../../../../redux/opennetwork-domains/action';
import { selectOpennetworkDomainsListItems } from '../../../../../../redux/opennetwork-domains/selector';
import moment from 'moment';

interface NetworkLogState {
  [key: string]: any;
}

const ManagementOpenNetworkLog = () => {
  const dispatch = useAppDispatch()
  const libraryData = useSelector(selectListItems)
  const domainListData = useSelector(selectOpennetworkDomainsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectOpenNetworkLogs, setSelectOpenNetworkLogs] = useState<any>({
    TransactionId: '',
    MessageId: '',
    BuyerId: '',
    SellerId: '',
    DomainId: '',
    City: '',
    StartDateIST: '',
    EndDateIST: '',
  });
  const [showResults, setShowResults] = useState(false);

  const dateRangesList: any = [
    { Description: '15 mins', Value: '10' },
    { Description: '30 mins', Value: '20' },
    { Description: '1 hour', Value: '30' },
    { Description: '4 hours', Value: '40' },
    { Description: '8 hours', Value: '50' },
    { Description: '12 hours', Value: '60' },
    { Description: '24 hours', Value: '70' },
    { Description: '48 hours', Value: '80' },
    { Description: 'Custom', Value: '90' },
  ];

  useEffect(() => {
  }, [selectOpenNetworkLogs])

  const handleInnerFormChange = (event: any, field: string): void => {
    setSelectOpenNetworkLogs(prev => ({
      ...prev,
      [field]: event,
    }));
  };

  const handleCustomDurationChange = (event: string, field: string): void => {
    const durationMap: Record<string, number> = {
      '10': 15,
      '20': 30,
      '30': 60,
      '40': 240,
      '50': 480,
      '60': 720,
      '70': 1440,
      '80': 2880
    };

    const updated: NetworkLogState = {
      ...selectOpenNetworkLogs,
      [field]: event
    };

    if (field === 'DurationUnitId') {
      const durationInMinutes = durationMap[event];

      if (event !== '90' && durationInMinutes) {
        const endDateIST = moment('Asia/Kolkata');
        const startDateIST = endDateIST.clone().subtract(durationInMinutes, 'minutes');

        updated.StartDateIST = startDateIST.format('YYYY-MM-DDTHH:mm');
        updated.EndDateIST = endDateIST.format('YYYY-MM-DDTHH:mm');
      } else {
        // Optional: Clear dates if 'Custom' (90) is selected
        updated.StartDateIST = '';
        updated.EndDateIST = '';
      }
    }

    setSelectOpenNetworkLogs(updated);
  };

  const fetchTenantOpenNetworkDomainsList = async () => {
    dispatch(opennetworkDomains.resetAction({ actionType: 'list' }))
    dispatch(opennetworkDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null //to get all records
          }
        ],
        "Pagination": {

        }
      }
    }))
  }

  const formatDomainListData = (data: any) => {
    return _.map(data, (items: any) => {
      const item = {
        Id: items?.Id,
        Code: items?.Code,
        Name: `${items?.Name} (${items?.Code})`,
      };
      return item
    });
  };

  useEffect(() => {
    fetchTenantOpenNetworkDomainsList()
    setIsLoading(false)
  }, []
  )

  const handleClearFilter = (event: any) => {
    event.preventDefault();
    setSelectOpenNetworkLogs({
      TransactionId: '',
      MessageId: '',
      BuyerId: '',
      SellerId: '',
      DomainId: '',
      City: '',
      StartDateIST: '',
      EndDateIST: '',
    });
    setShowResults(false);
  };

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    setShowResults(true);
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <div>
          <OpenNetworkLogComponent
            key={JSON.stringify(selectOpenNetworkLogs)}
            handleInnerFormChange={handleInnerFormChange}
            handleCustomDurationChange={handleCustomDurationChange}
            selectOpenNetworkLogs={selectOpenNetworkLogs}
            handleFormSubmit={handleFormSubmit}
            handleClearFilter={handleClearFilter}
            actionList={libraryData?.result?.RetailRequestType}
            // dateRangesList={libraryData?.result?.DateTimeWindow}
            domainList={formatDomainListData(domainListData?.result?.items)}
            showResults={showResults}
            dateRangesList={dateRangesList}
          />
        </div>
      }
    </>
  )
};

export default ManagementOpenNetworkLog;
